import { Trans, useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

/** The counted nouns, keys under `library.collections.counts` (`_one` / `_other`). */
export type LibraryCountNoun = 'resources' | 'topics' | 'audiences' | 'twins'

export interface LibraryCountPhraseProps {
  noun: LibraryCountNoun
  count: number
  /** The number's classes (strong); the noun inherits the parent's muted tone. */
  numberClassName?: string
  testId?: string
}

/**
 * A count read number first, the way editorial pages do ("5 resources",
 * "1 Topic", "608 twins"), with the number emphasized. The locale string
 * places the number (`<n>{{count}}</n>`), so word order stays per language.
 */
export function LibraryCountPhrase(props: LibraryCountPhraseProps) {
  const { noun, count, numberClassName, testId } = props

  const { t, i18n } = useTranslation('app')

  const value = new Intl.NumberFormat(i18n.language || 'en').format(count)

  return (
    <span className="whitespace-nowrap" data-testid={testId}>
      <Trans
        t={t}
        i18nKey={`library.collections.counts.${noun}`}
        count={count}
        values={{ value }}
        components={{ n: <span className={cn('font-medium tabular-nums text-foreground', numberClassName)} /> }}
      />
    </span>
  )
}
